var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-combobox',_vm._g(_vm._b({staticClass:"combobox-drop-down-container",class:{
      required: _vm.isRequired,
      'select-drop-down': true,
      'custom-selection': !!_vm.$scopedSlots.selection,
      'has-value': !!_vm.$attrs.value
    },style:({color: (_vm.brandBgColor + " !important")}),attrs:{"multiple":"","items":_vm.items,"menuProps":_vm.menuProps,"item-color":"rgb(84, 210, 140)"}},'v-combobox',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }